import styled from '@emotion/styled'
import { memo, useCallback } from 'react'
import { avatarUrl } from '../../../mfcLogic/avatarPreviewUrl'

const StyledCellImage = styled('img')({
    verticalAlign: 'bottom',
    width: '100%',
})

interface ICellImage {
    id: string | number
    slug?: string
    size?: number
    onLoad?(): void
    styleOverrides?: any
}

const CellImage = memo((props: ICellImage) => {
    const { styleOverrides, size = 300, onLoad, slug, id } = props
    const imgSrc = avatarUrl(id, size)

    const handleOnLoad = useCallback(() => {
        onLoad?.()
    }, [onLoad])

    return (
        <StyledCellImage
            data-testid="ModelTile__Image"
            alt={`Enter ${slug}'s Room`}
            onLoad={handleOnLoad}
            src={imgSrc}
            css={styleOverrides}
            id={`avatar-${id}`}
        />
    )
})

export default CellImage
